<div class="sidenav-menu" #sidenav (click)="this.divWidth = this.currentWidth">
  <!-- <app-logo-box [divWidth]="divWidth"/> -->
  <a routerLink="/" class="logo">
      <span class=""><img width="40px" src="assets/images/jata-mufti-160h.png" alt="logo"></span>&nbsp;
      @if(divWidth == 260){
        <span style="color:rgb(0, 0, 0);  font-weight: 700">e-Falak Selangor</span>
      }
  </a>
  <!-- <button class="button-sm-hover" (click)="changeSidebarSize()">
    <i class="ti ti-circle align-middle"></i>
  </button> -->


  <button class="button-close-fullsidebar"data-bs-toggle="collapse"
  data-bs-target="#topnav-menu-content"  (click)="toggleMobileMenu()">
    <i class="ti ti-x align-middle"></i>
  </button>

  <ngx-simplebar data-simplebar>
    <ul class="side-nav">
      @for (item of menuItems; track item.label;let first = $first) {
      @if(item.isTitle){
      <li class="side-nav-title">{{item.label}}</li>
      }@else {
      @if (hasSubmenu(item)) {
      <ng-container
        *ngTemplateOutlet="
                MenuItemWithChildren;
                context: { menu: item,linkClassName: 'side-nav-link nav-link-ref',subMenuClassNames: 'sub-menu',itemClassName: 'side-nav-item'}">
      </ng-container>
      }@else {
      <ng-container
        *ngTemplateOutlet="MenuItem; context: {menu: item,linkClassName: 'side-nav-link nav-link-ref',itemClassName: 'side-nav-item' }">
      </ng-container>
      }
      }
      }
    </ul>

    <!-- <div class="help-box text-center">
      <img src="assets/images/coffee-cup.svg" height="90" alt="Helper Icon Image" />
      <h5 class="mt-3 fw-semibold fs-16">Unlimited Access</h5>
      <p class="mb-3 text-muted">Upgrade to plan to get access to unlimited reports</p>
      <a href="javascript: void(0);" class="btn btn-danger btn-sm">Upgrade</a>
    </div> -->

    <div class="clearfix"></div>
  </ngx-simplebar>
</div>


<ng-template #MenuItemWithChildren let-menu="menu" let-itemClassName="itemClassName" let-linkClassName="linkClassName"
  let-subMenuClassNames="subMenuClassNames">
  <li [class]="itemClassName">
    <a [class]="linkClassName" [ngClass]="{ active: activeMenuItems.includes(menu.key) }"
      (click)="toggleMenuItem(menu, collapse)" role="button" [attr.aria-expanded]="!menu.collapsed"
      aria-controls="sidebarDashboards" [attr.aria-controls]="menu.key" style="white-space: pre-line;">
      @if (menu.icon) {
      <span class="menu-icon">
        <i class="ti {{menu.icon}}"></i>
      </span>
      }
      <span class="menu-text" style="white-space: pre-line; line-height: 1.2;
    "> {{ menu.label }} </span>
      <span class="menu-arrow"></span>
    </a>
    <div #collapse="ngbCollapse"  [(ngbCollapse)]="menu.collapsed" class="collapse"  id="sidebarDashboards">
      <ul [class]="subMenuClassNames">
        @for (child of menu.children; track child.label) {
        @if (hasSubmenu(child)) {
        <ng-container
          *ngTemplateOutlet="
                MenuItemWithChildren;
                context: {menu: child,linkClassName: 'side-nav-link nav-link-ref',itemClassName: 'side-nav-item', subMenuClassNames: 'sub-menu'}">
        </ng-container>
        } @else {
        <ng-container *ngTemplateOutlet="
                MenuItem;
                context: {menu: child,linkClassName: 'side-nav-link nav-link-ref',itemClassName: 'side-nav-item'}">
        </ng-container>
        }
        }
      </ul>
    </div>
  </li>
</ng-template>

<ng-template #MenuItem let-menu="menu" let-linkClassName="linkClassName" let-itemClassName="itemClassName">
  <li [class]="itemClassName" [ngClass]="{ active: activeMenuItems.includes(menu.key) }">
    <ng-container *ngTemplateOutlet=" MenuItemLink;context: { menu: menu, className: linkClassName }">
    </ng-container>
  </li>
</ng-template>

<ng-template #MenuItemLink let-menu="menu" let-className="className">
  <!-- <a [routerLink]="menu.url" [class]="className" (click)="toggleMobileMenu()"
    [ngClass]="{ active: activeMenuItems.includes(menu.key), disabled:menu.isDisabled }"
    [attr.aria-controls]="menu.key">
    @if (menu.icon) {
    <span class="menu-icon">
      <i class="ti {{menu.icon}}"></i>
    </span>
    <span class="menu-text" style="white-space: break-spaces;">{{ menu.label }}</span>
    } @else {
    {{ menu.label }}
    }
    @if (menu.badge) {
    <span class="badge rounded-pill text-end bg-{{ menu.badge.variant }}">{{
      menu.badge.text
      }}</span>
    }
  </a> -->
  @if(menu.key == 'manual-pengguna'){
      <a [href]="userManualLink" target="_blank"
      [class]="className" 
      (click)="onMenuItemClick(menu.key)"
      [attr.aria-controls]="menu.key" style="white-space: pre-line; line-height: 1.2;
    ">
      @if (menu.icon) {
        <span class="menu-icon">
          <i class="ti {{menu.icon}}"></i>
        </span>
        <span class="menu-text">{{ menu.label }}</span>
      } @else {
        {{ menu.label }}
      }
      @if (menu.badge) {
        <span class="badge rounded-pill text-end bg-{{ menu.badge.variant }}">
          {{ menu.badge.text }}
        </span>
      }
   </a>
  }@else {
    <a [routerLink]="menu.url" 
    routerLinkActive="active" 
    [routerLinkActiveOptions]="{ exact: true }"
    [class]="className" 
    (click)="onMenuItemClick(menu.key)"
    [ngClass]="{ active: activeMenuItems.includes(menu.key), disabled: menu.isDisabled }"
    [attr.aria-controls]="menu.key" style="white-space: pre-line; line-height: 1.2;
    ">
    @if (menu.icon) {
      <span class="menu-icon">
        <i class="ti {{menu.icon}}"></i>
      </span>
      <span class="menu-text">{{ menu.label }}</span>
    } @else {
      {{ menu.label }}
    }
    @if (menu.badge) {
      <span class="badge rounded-pill text-end bg-{{ menu.badge.variant }}">
        {{ menu.badge.text }}
      </span>
    }
 </a>
  }
 

</ng-template>